import { locateID, locate } from "@xbs/lib-dom";
import { isSameId } from "../../helpers";
import { menuIsEnabled } from "../../common/menu";
export function userMenu(node, config) {
    const handleUp = (event) => {
        const node = locate(event, "data-user-menu-id");
        const { menuState, draggableIds, menu } = config.api.getState();
        if (node && !draggableIds.length) {
            const userMenuId = locateID(event, "data-user-menu-id");
            if (!menuState ||
                (menuState && !isSameId(menuState.id, userMenuId))) {
                menuState && config.api.exec("close-menu", { ...menuState });
                if (menuIsEnabled(menu, { type: "user" })) {
                    const rect = node.getBoundingClientRect();
                    config.api.exec("open-menu", {
                        id: userMenuId,
                        type: "user",
                        coords: {
                            x: rect.left,
                            y: rect.bottom,
                        },
                    });
                }
            }
            event.stopPropagation();
        }
        else if (menuState && menuState.type === "user") {
            config.api.exec("close-menu", { ...menuState });
        }
    };
    node.addEventListener("pointerover", handleUp);
    return {
        destroy() {
            node.removeEventListener("pointerover", handleUp);
        },
    };
}
//# sourceMappingURL=userMenu.js.map